<h1 mat-dialog-title class="pre-line p-2 text-center">{{message}}</h1>
<div>
    @if (data.withHashCheck) {
    <mat-form-field class="col">
        <input matInput [(ngModel)]="UserHash" placeholder="Confirmation">
    </mat-form-field>
    }
    @if (WithCancelButton) {
    <button class="col-6 squared-flat-button" color="primary" mat-stroked-button (click)="onCancel()">
        Non
    </button>
    }
    @if (WithCancelButton) {
    <button class="col-6 squared-flat-button" color="warn" mat-stroked-button (click)="onConfirm()" [disabled]="UserHash !== Hash">
        Oui
    </button>
    }
    @if (!WithCancelButton) {
    <button class="col-12 squared-flat-button" color="primary" mat-stroked-button (click)="onConfirm()">
        OK
    </button>
    }
</div>